






























import { PropType } from 'vue';
import { mapState } from 'vuex';

import VTabsHash from '@/components/VTabsHash.vue';

const StakingViewProgramsGeneral = (): any =>
  import('./StakingViewProgramsGeneral.vue');
const StakingViewProgramsHappyHour = (): any =>
  import('./StakingViewProgramsHappyHour.vue');

import { TTabsItem } from '@/api/schema';

export default {
  name: 'StakingViewPrograms',
  components: {
    VTabsHash,
    StakingViewProgramsGeneral,
    StakingViewProgramsHappyHour
  },
  props: {
    modal: {
      type: Boolean as PropType<boolean>,
      default: (): boolean => false
    }
  },
  data(): any {
    return {
      tab: 0
    };
  },
  computed: {
    ...mapState('Auth', ['tokenSymbol']),
    tabItems(): TTabsItem[] {
      return [
        {
          id: 'general',
          text: `${this.tokenSymbol} Programs`,
          value: 'general',
          component: 'StakingViewProgramsGeneral',
          visible: true
        },
        {
          id: 'happy_hours',
          text: 'Happy Hours',
          value: 'happy_hours',
          component: 'StakingViewProgramsHappyHour',
          visible: this.$role.can.read('happy_hours')
        }
      ].filter(({ visible }) => visible);
    }
  }
};
